/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LabelTranListDetModel { 
    labelTranDetId?: number;
    labelTranId?: number;
    ordinal?: number;
    itemNumber?: string | null;
    itemDescription?: string | null;
    unit?: number | null;
    uOfM?: string | null;
    quantity?: number;
    uniqueIdentifierType?: number | null;
    uniqueIdentifier?: string | null;
    batchIdentifierType?: number | null;
    batchIdentifier?: string | null;
    fromSellByDate?: string | null;
    toSellByDate?: string | null;
    barcodeSource?: string | null;
    reference?: string | null;
    timeStamp?: string;
    statusId?: number;
}

